module.exports = __webpack_public_path__ + "img/premio-01.6d829f14.png";